module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shouyin"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("订单支付-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "PaymentOrder"
    }
  }, [_c('div', {
    staticClass: "imagess"
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "Order"
    }, [_c('div', {
      staticClass: "zhorderNumber"
    }, [_c('div', {
      staticClass: "numCon"
    }, [_c('p', {
      staticClass: "number"
    }, [_vm._v("订单已生成！订单号：" + _vm._s(item.order_id))]), _vm._v(" "), _c('p', {
      staticClass: "zhcontents"
    }, [_vm._v("\n\t            \t课程名称：" + _vm._s(item.name) + "\n\t            "), _c('br'), _vm._v("\n\t            \t 下单时间：" + _vm._s(item.order_date) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "paymentt"
    }, [_c('p', {
      staticClass: "pay"
    }, [_vm._v("待支付")]), _vm._v(" "), _c('p', {
      staticClass: "payNowo"
    }, [_vm._v("￥" + _vm._s(item.unit_price))])])]), _vm._v(" "), _c('div', {
      staticClass: "close",
      attrs: {
        "id": "closeT"
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "platform"
  }, [_c('div', {
    staticClass: "payplatform actives",
    on: {
      "click": _vm.handle1
    }
  }, [_vm._v("支付平台")]), _vm._v(" "), _c('div', {
    staticClass: "payplatform payplatformTwo",
    on: {
      "click": _vm.handle2
    }
  }, [_vm._v("银行转账")])]), _vm._v(" "), _c('div', {
    staticClass: "clears"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay1),
      expression: "pay1"
    }],
    staticClass: "payCon"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [(_vm.wxzf) ? _c('div', {
    on: {
      "click": _vm.zhmask
    }
  }, [_c('router-link', {
    staticClass: "nextStep",
    attrs: {
      "to": {
        name: 'paymentQR',
        params: {
          id: _vm.hao
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("下一步")])], 1) : _vm._e(), _vm._v(" "), (_vm.zfbzf) ? _c('div', {
    staticClass: "nextStep",
    on: {
      "click": _vm.zfbzfb
    }
  }, [_vm._v("下一步")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clears"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay2),
      expression: "pay2"
    }],
    staticClass: "payCon account"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "paycard"
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('p', {
      staticClass: "label"
    }, [_vm._v("汇款备注请注明"), _c('span', [_vm._v("“订单号" + _vm._s(item.order_id) + "”")])])
  }), _vm._v(" "), _c('p', {
    staticClass: "label1"
  }, [_vm._v("请及时与客服联系确认到账情况")])], 2), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v("提示:如您选择线下转账，请在订单有效期内完成打款，如打款后订单状态未更新或未收到订单到账通知，")]), _vm._v(" "), _c('div', {
    staticClass: "next zhClose"
  }, [_c('div', {
    staticClass: "nextStep"
  }, [_c('router-link', {
    attrs: {
      "to": "/orderList"
    }
  }, [_vm._v("关闭")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhMask),
      expression: "zhMask"
    }],
    staticClass: "zhMask"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zhJudge),
      expression: "!zhJudge"
    }],
    staticClass: "zhPaymentResults"
  }, [_c('p', {
    staticClass: "zhPayment"
  }, [_vm._v("支付结果")]), _vm._v(" "), _c('p', {
    staticClass: "zhResults"
  }, [_vm._v("请您在新打开的页面上完成付款,付款完成前请不要关闭此窗口。完成付款后请根据您的情况点击下面的按钮：")]), _vm._v(" "), _c('div', {
    staticClass: "zhButton"
  }, [_c('div', {
    staticClass: "zhBut",
    on: {
      "click": _vm.zhbut
    }
  }, [_vm._v("支付成功")]), _vm._v(" "), _c('div', {
    staticClass: "zhZhifu",
    on: {
      "click": _vm.zhzhifu
    }
  }, [_vm._v("支付失败，继续支付 >")])]), _vm._v(" "), _c('div', {
    staticClass: "zhCloses",
    on: {
      "click": _vm.zhmaskes
    }
  }, [_c('div', {
    staticClass: "zhC"
  }), _vm._v(" "), _c('div', {
    staticClass: "zhC zhC1"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhJudge),
      expression: "zhJudge"
    }],
    staticClass: "zhPaymentResults"
  }, [_c('p', {
    staticClass: "zhPayment"
  }, [_vm._v("支付结果")]), _vm._v(" "), _c('p', {
    staticClass: "zhResults"
  }, [_vm._v("抱歉，当前尚未收到银行或第三方平台的支付确认，为 避免重复支付，请确认您的银行卡或平台账户是否已经扣款。如已扣款请联系以诺平台客服 4008200025-6 进行处理。")]), _vm._v(" "), _c('div', {
    staticClass: "zhButton zhActive"
  }, [_c('div', {
    staticClass: "zhBut",
    on: {
      "click": _vm.clock
    }
  }, [_vm._v("我知道了")])]), _vm._v(" "), _c('div', {
    staticClass: "zhCloses",
    on: {
      "click": _vm.zhmaskes
    }
  }, [_c('div', {
    staticClass: "zhC"
  }), _vm._v(" "), _c('div', {
    staticClass: "zhC zhC1"
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "select"
  }, [_c('li', {
    staticClass: "wx"
  }, [_c('p', {
    staticClass: "patch1 activeT",
    staticStyle: {
      "border-color": "rgb(17, 204, 153)"
    }
  }, [_c('i', {
    staticStyle: {
      "display": "block"
    }
  })]), _c('span')]), _vm._v(" "), _c('li', {
    staticClass: "zfb"
  }, [_c('p', {
    staticClass: "patch2"
  }, [_c('i')]), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "zftishi"
  }, [_vm._v("温馨提醒：如果订单金额超过线上支付限额，推荐银行转账支付。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425cfcca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentOrder/PaymentOrder.vue
// module id = 551
// module chunks = 1